import React, { useEffect, useState } from 'react'
import styles from 'components/Order/OrderDetails/AttachmentsPreviewDialog/AttachmentsPreviewDialog.module.css'
import { PrimaryButton } from 'components/Shared/PrimaryButton'
import { Tooltip } from '@material-ui/core'
import { ReactComponent as Verified } from 'assets/icons/check.svg'
import { ReactComponent as DriverAccess } from 'assets/icons/wheel.svg'
import { ReactComponent as ContractorAccess } from 'assets/icons/user.svg'
import { useTranslation } from 'react-i18next'
import {
  rejectAttachment,
  setAttachmentContractorAccessAs,
  setAttachmentDriverAccessAs,
  setAttachmentVerifiedAs
} from 'services'
import {
  contractorAccessTooltip,
  driverAccessTooltip,
  verifiedTooltip
} from 'components/Shared/FileChip/AccessControls'
import { FilesPreviewDialog } from 'components/Shared/FilesPreviewDialog'
import { useAuth } from 'context/auth'
import { attachmentTypes } from 'components/Order/constants'

export function AttachmentsPreviewDialog ({
  open,
  attachments,
  onClose,
  initAttachment,
  attachmentSource,
  onAttachmentUpdated,
  onAttachmentRemove,
  onAttachmentChanged
}) {
  const [attachmentToShow, setAttachmentToShow] = useState()
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  const disabled= !hasAnyPrivileges([attachmentTypes.find(type => type.value === initAttachment?.type)?.requiredPrivilege?.write])

  useEffect(() => {
    if (attachments && initAttachment) {
      setAttachmentToShow(attachments.find(file => file.id === initAttachment.id))
    }
  }, [initAttachment, attachments])

  const onAttachmentUpdate = updatedAttachment => {
    onAttachmentUpdated && onAttachmentUpdated(updatedAttachment)
  }

  const contractorAccessClick = (attachment) => setAttachmentContractorAccessAs(attachmentToShow.id, !attachment.attachmentAccess.contractorAccess)
    .then(attachment => onAttachmentUpdate(attachment))

  const driverAccessClick = (attachment) => setAttachmentDriverAccessAs(attachmentToShow.id, !attachment.attachmentAccess.driverAccess)
    .then(attachment => onAttachmentUpdate(attachment))

  const verifiedClick = (verified) => setAttachmentVerifiedAs(attachmentToShow.id, verified)
    .then(attachment => onAttachmentUpdate(attachment))

  const reject = () => rejectAttachment(attachmentToShow.id).then(() => {
    onAttachmentRemove(attachmentToShow)
    const updatedAttachmentsListLength = attachments.filter(attachment => attachmentToShow.id !== attachment.id).length
    if (updatedAttachmentsListLength === 0) {
      onClose()
    } else {
      setAttachmentToShow(attachments[(attachments.indexOf(attachmentToShow) + 1) % attachments.length])
    }
  })

  function getIconClassName (accepted) {
    return `${styles.accessIcon} ${accepted ? styles.accepted : styles.denied}`
  }

  return (
    <FilesPreviewDialog
      open={open}
      files={attachments}
      filesSource={attachmentSource}
      fileToShow={initAttachment}
      onClose={onClose}
      onFileChanged={(file) => {
        onAttachmentChanged(file)
        setAttachmentToShow(file)
      }}
    >
      <div className='col'>
        {attachmentToShow && !disabled && [
          <div className='row justify-content-center mb-2'>
            <h3 className='mt-2'>{t('order.attachment.settings')}</h3>
            <Tooltip className='mx-3'
                     title={t(verifiedTooltip(attachmentToShow.verified))}>
              <Verified
                onClick={() => verifiedClick(!attachmentToShow.verified)}
                className={getIconClassName(attachmentToShow.verified)}/>
            </Tooltip>
            <Tooltip className='mx-3' title={t(driverAccessTooltip(attachmentToShow.attachmentAccess.driverAccess))}>
              <DriverAccess onClick={() => driverAccessClick(attachmentToShow)}
                            className={getIconClassName(attachmentToShow.attachmentAccess.driverAccess)}/>
            </Tooltip>

            <Tooltip className='mx-3'
                     title={t(contractorAccessTooltip(attachmentToShow.attachmentAccess.contractorAccess))}>
              <ContractorAccess onClick={() => contractorAccessClick(attachmentToShow)}
                                className={getIconClassName(attachmentToShow.attachmentAccess.contractorAccess)}/>
            </Tooltip>
          </div>,
          <div className='row'>
            {<div className={styles.dialogButton}>
              <PrimaryButton
                disabled={attachmentToShow.verified}
                onClick={() => verifiedClick(!attachmentToShow.verified)}
                label={'order.attachment.verify'}
              />
            </div>}
            {onAttachmentRemove && !attachmentToShow.verified && <div className={styles.dialogButton}>
              <PrimaryButton
                onClick={() => reject()}
                label={'order.attachment.reject'}
              />
            </div>}
            {onAttachmentRemove && attachmentToShow.verified && <div className={styles.dialogButton}>
              <PrimaryButton
                onClick={() => reject()}
                label={'order.attachment.delete'}
              />
            </div>}
          </div>]}
      </div>
    </FilesPreviewDialog>
  )
}
